import {ChangeDetectionStrategy, ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, HostListener, Inject, OnInit, signal, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {PushpinImage} from '../../classes/pushpin-image.class';
import {DrawOnImageDialogComponent} from '../draw-on-image-dialog/draw-on-image-dialog.component';
import {register} from "swiper/element/bundle";
import {DatePipe} from "@angular/common";

register();

export class ImageViewerData {
    public images: PushpinImage[];
    public viewIndex: number;
}

@Component({
    selector: 'app-pushpin-part-image-viewer-dialog',
    templateUrl: './pushpin-part-image-viewer-dialog.component.html',
    styleUrls: ['./pushpin-part-image-viewer-dialog.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        DatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PushpinPartImageViewerDialogComponent implements OnInit {

    @ViewChild('swiperRef') swiperComponent?;
    zoomlevel = 1;
    readonly showDrawing = signal<boolean>(false);

    constructor(
        public dialogRef: MatDialogRef<PushpinPartImageViewerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ImageViewerData,
        private dialog: MatDialog,
        private cdr: ChangeDetectorRef
    ) {
        if (data.images?.length) {
            this.showDrawing.set(!!data.images[0].image);
        }
    }

    ngOnInit(): void {
        const index = this.data.viewIndex;
        this.data.images = [...this.data.images.slice(index), ...this.data.images.slice(0, index)];
        this.data.viewIndex = 0;
    }

    @HostListener('click', ['$event'])
    public click(event) {
        if (event?.target?.localName !== 'img'
            && event?.srcElement?.className.indexOf('wiper-zoom-container') !== -1) {
            this.dialogRef.close();
        }
    }

    drawOnImage(event) {
        event.stopPropagation();
        const activeIndex = this.swiperComponent?.nativeElement.swiper.activeIndex;
        const dialogRef = this.dialog.open(DrawOnImageDialogComponent, {
            panelClass: 'image-viewer-dialog',
            data: this.data.images[activeIndex]
        });
        dialogRef.afterClosed().subscribe((updatedImage) => {
            if (updatedImage?.drawn_image) {
                this.cdr.markForCheck();
            }
        });
    }

    onScroll(event: WheelEvent) {
        if (event.deltaY < 0) {
            this.zoomlevel = this.zoomlevel + 1;
            this.swiperComponent?.nativeElement.swiper.zoom.in(this.zoomlevel);
        } else {
            if (this.zoomlevel > 1) {
                this.zoomlevel = this.zoomlevel - 1;
                this.swiperComponent?.nativeElement.swiper.zoom.in(this.zoomlevel);
            } else {
                this.swiperComponent?.nativeElement.swiper.zoom.out();
            }
        }
    }
}

